import React from 'react'
import { useTranslation } from 'react-i18next'

import AdGoogleCreateForm from './AdGoogleCreateForm'
import FormDrawerWrapper from '../../../../features/components/FormDrawerWrapper'

import { AD_GOOGLE_CREATE } from '../../../../constants/forms'

// If google ads campaign type = display (identified by AdvertisingChannelType = 3 ) then use regular ad create:
const AdGoogleCreate = ({ lineItemId, campaignId }) => {
  const { t } = useTranslation()

  return (
    <FormDrawerWrapper openButtonText={t('Create ad')} formName={AD_GOOGLE_CREATE}>
      <AdGoogleCreateForm lineItemId={lineItemId} campaignId={campaignId} />
    </FormDrawerWrapper>
  )
}

export default AdGoogleCreate
